import cx from 'classnames'

import { ImageLink } from 'lib/_types'

import ImageLoader from 'components/ImageLoader'
import { ExternalLink } from 'components'

import './style.scss'

type Props = ImageLink & {
  state?: string
}

export const ImageItem = ({ link, title, url, state }: Props) => (
  <ExternalLink
    className={cx(
      'ImageSlider__list__image',
      `ImageSlider__list__image--${state}`,
      {
        'ImageSlider__list__image--disabled': !link,
      }
    )}
    href={link}
    title={title}
  >
    <ImageLoader url={url} alt={title} disableViewportCheck />
  </ExternalLink>
)
